import { computed, defineComponent, ref, watch, type SetupContext } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

// Schweizer Mobilnummern beginnen (nach der führenden 0) mit 75-79
const MOBILE_NUMBER_PATTERN = /^(075|076|077|078|079)\d{7}$/;

const formatSwissNumber = (digits: string): string => {
  const parts = [
    digits.slice(0, 3),
    digits.slice(3, 6),
    digits.slice(6, 8),
    digits.slice(8, 10),
  ].filter((part) => part.length > 0);
  return parts.join(" ");
};

let instanceCounter = 0;

interface Props {
  modelValue: string | null;
  label: string;
  error: string;
  className: string;
}

export default defineComponent({
  template: html,
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
  },
  emits: {
    "update:modelValue": (_value: string | null) => true,
    change: () => true,
  },
  setup(props: Props, { emit }: SetupContext) {
    const { t } = useI18n();

    // eindeutige ID, da diese Komponente mehrfach gleichzeitig gerendert werden kann
    const inputId = `swiss-mobile-number-entry-${++instanceCounter}`;
    const displayValue = ref(formatSwissNumber(props.modelValue ?? ""));

    watch(() => props.modelValue, (value) => {
      const digits = (value ?? "").replace(/\D/g, "");
      if (digits != displayValue.value.replace(/\D/g, "")) {
        displayValue.value = formatSwissNumber(digits);
      }
    });

    const digits = computed(() => displayValue.value.replace(/\D/g, ""));

    const localError = computed(() => {
      if (0 == digits.value.length) {
        return "";
      }
      if (!MOBILE_NUMBER_PATTERN.test(digits.value)) {
        return t("SwissMobileNumberEntry_Invalid");
      }
      return "";
    });

    const displayedError = computed(() => localError.value || props.error);

    // Formatiert während der Eingabe und meldet den reinen Ziffernwert nach aussen
    const onInput = (evt: Event) => {
      const target = evt.target as HTMLInputElement;
      const raw = target.value.replace(/\D/g, "").slice(0, 10);
      displayValue.value = formatSwissNumber(raw);
      target.value = displayValue.value;
      emit("update:modelValue", 0 < raw.length ? raw : null);
    };

    const onChange = () => {
      emit("change");
    };

    return {
      t,
      inputId,
      displayValue,
      displayedError,
      onInput,
      onChange,
    };
  },
} as any);
